import { useQuery } from 'react-query';
import { queryAllStatsDIR } from './useAllStatsDIR.query';
import { UseAllStatsDIROptions } from './useAllStatsDIR.types';
import { AllStatsDIRResponse } from '../../../types/api/endpoints/stats/stats.types';

export const ALL_STATS_DIR_QUERY_KEY = 'ALL_STATS_DIR';

export const useAllStatsDIR = (options?: UseAllStatsDIROptions) => {
  return useQuery<AllStatsDIRResponse, Error>(ALL_STATS_DIR_QUERY_KEY, () => queryAllStatsDIR(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
